import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import PageTitle from '@/components/v2/PageTitle.vue';
import DeliveryAreaForm from '@/components/v2/DeliveryAreaForm.vue';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import DeliveryAreaUpdate from '@/plugins/graphql/mutations/v2/delivery-area-update.gql';
// import AreaCityFragment from '@/plugins/graphql/fragments/v2/delivery-area-city.gql';
import DeliveryAreaCities from '@/plugins/graphql/queries/v2/delivery-area-cities.gql';
import { successfulUpdate } from '@/helpers/mixins/LocalizationHelper';
import DeliveryAreaCityDetails from '@/plugins/graphql/queries/v2/delivery-area-city.gql';
import DeliveryAreasMixin from '@/helpers/vue_mixins/v2/ecommerce/DeliveryAreasMixin';
import { DeliveryAreaCityModel } from '@/helpers/entities/models/DeliveryAreaCityModel';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
let DeliveryAreaEdit = class DeliveryAreaEdit extends mixins(AlertMixin, RouterParamsAppMixin, DeliveryAreasMixin, CleverTapEventsMixin) {
    constructor() {
        super(...arguments);
        this.deliveryAreaCity = null;
    }
    get queryOnFlight() {
        return this.$apollo.queries.deliveryAreaCity.loading;
    }
    get formData() {
        const { deliveryAreaCity } = this;
        const data = {
            regionName: null,
            cityName: null,
            deliveryFee: 0.0,
        };
        if (deliveryAreaCity) {
            const { uuid, regionName, name, deliveryFee } = deliveryAreaCity;
            const cityName = name;
            return {
                uuid,
                cityName,
                regionName,
                deliveryFee,
            };
        }
        return data;
    }
    async onSubmit(form) {
        this.mutationRequestOnFlight();
        this.update(form)
            .then(() => {
            const msg = successfulUpdate('Delivery Area');
            this.successNotification(msg);
            this.deliveryAreaAction('SUBMIT EDIT');
            this.goToDeliveryAreasPage();
        })
            .catch((e) => {
            this.errorNotification(e.message);
        })
            .finally(() => {
            this.requestDone();
        });
    }
    async update(form) {
        const { deliveryFee } = form;
        const appUuid = this.appUUID;
        await this.$apollo.mutate({
            mutation: DeliveryAreaUpdate,
            variables: {
                input: {
                    deliveryFee,
                    areaCityUuid: this.uuid,
                    appUuid: this.appUUID,
                },
            },
            // update(cache: any, result: any) {
            //   const {
            //     data: {
            //       deliveryAreaUpdate: { areaCity },
            //     },
            //   } = result;
            //   cache.writeFragment({
            //     id: areaCity.uuid,
            //     fragment: AreaCityFragment,
            //     data: areaCity,
            //     fragmentName: 'DeliveryAreaCity',
            //   });
            // },
            refetchQueries: [
                {
                    query: DeliveryAreaCities,
                    variables: {
                        appUuid,
                        regionCode: null,
                    },
                },
            ],
        });
    }
};
__decorate([
    Prop({ type: String, required: true })
], DeliveryAreaEdit.prototype, "uuid", void 0);
DeliveryAreaEdit = __decorate([
    Component({
        components: {
            PageTitle,
            DeliveryAreaForm,
        },
        apollo: {
            deliveryAreaCity: {
                query: DeliveryAreaCityDetails,
                variables() {
                    const areaCityUuid = this.uuid;
                    return {
                        areaCityUuid,
                    };
                },
                update(data) {
                    return new DeliveryAreaCityModel(data.fetchDeliveryAreaCity);
                },
            },
        },
    })
], DeliveryAreaEdit);
export default DeliveryAreaEdit;
